import { LazyLoadImage } from 'react-lazy-load-image-component';
import Skeleton from 'react-loading-skeleton';
import { Link } from 'react-scroll';

import { useWindowSize } from '#hooks/index';
import { Typography } from '#atoms/index';

const GameJamStage = ({ scrollToWorkshop }) => {
  const { isMobile, isDesktop } = useWindowSize();

  return (
    <section className="game-jam-stage-Wrapper">
      <div className="game-jam-stage flex">
        <div className="game-jam-stage__image mb-4">
          <LazyLoadImage
            width={isMobile ? '53px' : '364px'}
            effect="blur"
            alt={'monster-stage'}
            src={'./game-jam/stage/monster-stage.svg'}
            placeholder={<Skeleton width="100%" height="100%" />}
          />
        </div>

        <div className="game-jam-stage__text">
          <div className="game-jam-stage__title pb-4">
            <Typography
              variant="regular regular-2 bold"
              tag="h2"
              style={{ color: '#AC84FF', lineHeight: isMobile ? '44px' : '60px' }}
            >
              Etapas del concurso
            </Typography>
          </div>

          {/* Why participate */}
          <ul className="game-jam-stage__list mt-5">
            <li className="game-jam-stage__list__item">
              <div className="game-jam-stage__list__item__container_text flex items-center">
                <p className="stage-number">1</p>
                <Typography
                  variant="regular regular-6 stage-text"
                  tag="p"
                  style={{ color: '#DBD1FD', lineHeight: isMobile ? '20px' : '24px' }}
                >
                  Inscríbete hasta el 11 de octubre{' '}
                  <Link
                    className="game-jam-stage__list__item__container_text_link"
                    to="workshop"
                    smooth
                    duration={1000}
                    offset={scrollToWorkshop}
                  >
                    aquí.
                  </Link>
                </Typography>
              </div>
            </li>
            <li className="game-jam-stage__list__item">
              <div className="game-jam-stage__list__item__container_text flex items-center">
                <p className="stage-number">2</p>
                <Typography
                  variant="regular regular-6 stage-text"
                  tag="p"
                  style={{ color: '#DBD1FD', lineHeight: isMobile ? '20px' : '24px' }}
                >
                  Evento de lanzamiento el 5 de diciembre.
                </Typography>
              </div>
            </li>
            <li className="game-jam-stage__list__item">
              <div className="game-jam-stage__list__item__container_text flex items-center">
                <p className="stage-number">3</p>
                <Typography
                  variant="regular regular-6 stage-text"
                  tag="p"
                  style={{ color: '#DBD1FD', lineHeight: isMobile ? '20px' : '24px' }}
                >
                  Asiste a las sesiones de Q&A con nuestros profesores expertos del 5 al
                  10 de diciembre.
                </Typography>
              </div>
            </li>
            <li className="game-jam-stage__list__item">
              <div className="game-jam-stage__list__item__container_text flex items-center">
                <p className="stage-number">4</p>
                <Typography
                  variant="regular regular-6 stage-text"
                  tag="p"
                  style={{ color: '#DBD1FD', lineHeight: isMobile ? '20px' : '24px' }}
                >
                  Gran Final: 16 de diciembre
                </Typography>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default GameJamStage;
